import React, { useState } from "react";
import { Link } from "react-router-dom";

// import NotificationDropdown from "components/Dropdowns/NotificationDropdown.js";
import UserDropdown from "components/Dropdowns/UserDropdown.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

export default function Sidebar() {
  const [collapseShow, setCollapseShow] = React.useState("hidden");

  const userLogin = useSelector((state) => state.global.userLogin);

  const [configurationDropdown, setConfigurationDropdown] = useState(true);
  const [masterDataDropdown, setMasterDataDropdown] = useState(true);
  const [transactionDropdown, setTransactionDropdown] = useState(true);
  const [reportDropdown, setReportDropdown] = useState(true);

  if (userLogin.role === "adminSistem") {
    return (
      <>
        <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-15 py-4 px-6">
          <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
            {/* Toggler */}
            <button
              className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
              type="button"
              onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
            >
              {/* <i className="fas fa-bars"></i> */}
              <i>
                <FontAwesomeIcon icon="fas fa-bars" />
              </i>
            </button>
            {/* Brand */}
            <Link
              className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
              to="/masterData"
            >
              Sistem Keuangan ALC
            </Link>
            {/* User */}
            <ul className="md:hidden items-center flex flex-wrap list-none">
              <li className="inline-block relative">
                {/* <NotificationDropdown /> */}
              </li>
              <li className="inline-block relative">
                <UserDropdown />
              </li>
            </ul>
            {/* Collapse */}
            <div
              className={
                "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
                collapseShow
              }
            >
              {/* Collapse header */}
              <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
                <div className="flex flex-wrap">
                  <div className="w-6/12">
                    <Link
                      className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                      to="/masterData"
                    >
                      Sistem Keuangan ALC
                    </Link>
                  </div>
                  <div className="w-6/12 flex justify-end">
                    <button
                      type="button"
                      className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                      onClick={() => setCollapseShow("hidden")}
                    >
                      {/* <i className="fas fa-times"></i> */}
                      <i>
                        <FontAwesomeIcon icon="fas fa-times" />
                      </i>
                    </button>
                  </div>
                </div>
              </div>
              {/* Form */}
              {/* <form className="mt-6 mb-4 md:hidden">
              <div className="mb-3 pt-0">
                <input
                  type="text"
                  placeholder="Search"
                  className="px-3 py-2 h-12 border border-solid  border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
                />
              </div>
            </form> */}
              <h6
                className="md:min-w-full text-blueGray-500 text-xs uppercase cursor-pointer font-bold block pt-1 pb-4 no-underline"
                onClick={(e) => {
                  setConfigurationDropdown(!configurationDropdown);
                }}
              >
                Configuration
              </h6>
              <ul
                className={
                  configurationDropdown === false
                    ? " md:min-w-full list-none md:flex-col flex flex-col"
                    : " md:min-w-full list-none md:flex-col hidden flex-col"
                }
              >
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/config/User") !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/config/User"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf("/config/User") !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-user-cog" />
                    </i>{" "}
                    Users
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/config/AkunCategory") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/config/AkunCategory"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/config/AkunCategory"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-battery-quarter" />
                    </i>{" "}
                    Kategori Akun
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/config/AkunSubCategory"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/config/AkunSubCategory"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/config/AkunSubCategory"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-battery-half" />
                    </i>{" "}
                    Sub Kategori Akun
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/config/AkunSubChildCategory"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/config/AkunSubChildCategory"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/config/AkunSubChildCategory"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-battery-full" />
                    </i>{" "}
                    Sub Child Kategori Akun
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/config/assetKategori") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/config/assetKategori"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/config/assetKategori"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-box-open" />
                    </i>{" "}
                    Kategori Asset
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/config/BidangUsaha") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/config/BidangUsaha"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf("/config/BidangUsaha") !==
                        -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-warehouse" />
                    </i>{" "}
                    Bidang Usaha
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/config/PelangganJenis"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/config/PelangganJenis"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/config/PelangganJenis"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-users" />
                    </i>{" "}
                    Jenis Pelanggan
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/config/Backup") !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/config/Backup"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf("/config/Backup") !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fa-solid fa-memory" />
                    </i>{" "}
                    Backup Data
                  </Link>
                </li>
              </ul>

              {/* Divider */}
              <hr className="my-4 md:min-w-full" />
              {/* Heading */}
              <h6
                className="md:min-w-full text-blueGray-500 text-xs cursor-pointer uppercase font-bold block pt-1 pb-4 no-underline"
                onClick={(e) => setMasterDataDropdown(!masterDataDropdown)}
              >
                Master Data
              </h6>

              {/* Navigation */}
              <ul
                className={
                  masterDataDropdown === false
                    ? " md:min-w-full list-none md:flex-col flex flex-col"
                    : " md:min-w-full list-none md:flex-col hidden flex-col"
                }
              >
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/masterData/KodeAkun") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/masterData/KodeAkun"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/masterData/KodeAkun"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-file-alt" />
                    </i>{" "}
                    Kode Akun
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/masterData/UnitUsaha") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/masterData/UnitUsaha"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/masterData/UnitUsaha"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-briefcase" />
                    </i>{" "}
                    Unit Usaha
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/masterData/Pelanggan") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/masterData/Pelanggan"
                  >
                    <i
                      className={
                        " mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/masterData/Pelanggan"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-user-friends" />
                    </i>{" "}
                    Pelanggan
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/masterData/Marketing") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/masterData/Marketing"
                  >
                    <i
                      className={
                        " mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/masterData/Marketing"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-map-marked" />
                    </i>{" "}
                    Marketing
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/masterData/anggaranPemasukan"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/masterData/anggaranPemasukan"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/masterData/anggaranPemasukan"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-wallet" />
                    </i>{" "}
                    Anggaran Pemasukan
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/masterData/anggaranPengeluaran"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/masterData/anggaranPengeluaran"
                  >
                    <i
                      className={
                        " mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/masterData/anggaranPengeluaran"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-money-bill-wave" />
                    </i>{" "}
                    Anggaran Pengeluaran
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/masterData/dataAsset") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/masterData/dataAsset"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/masterData/dataAsset"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-archive" />
                    </i>{" "}
                    Data Asset
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/masterData/DataTahun") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/masterData/DataTahun"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/masterData/DataTahun"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fa-solid fa-calendar-days" />
                    </i>{" "}
                    Data Tahun
                  </Link>
                </li>
              </ul>

              {/* Divider */}
              <hr className="my-4 md:min-w-full" />
              {/* Heading */}
              <h6
                className="md:min-w-full text-blueGray-500 text-xs cursor-pointer uppercase font-bold block pt-1 pb-4 no-underline"
                onClick={(e) => setTransactionDropdown(!transactionDropdown)}
              >
                Transaction
              </h6>

              {/* Navigation */}
              <ul
                className={
                  transactionDropdown === false
                    ? " md:min-w-full list-none md:flex-col flex flex-col"
                    : " md:min-w-full list-none md:flex-col hidden flex-col"
                }
              >
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/transaction/transaksiMasuk"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/transaction/transaksiMasuk"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/transaction/transaksiMasuk"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-envelope-open-text" />
                    </i>{" "}
                    Transaksi Masuk
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/transaction/transaksiKeluar"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/transaction/transaksiKeluar"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/transaction/transaksiKeluar"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-mail-bulk" />
                    </i>{" "}
                    Transaksi Keluar
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/transaction/transaksiJurnal"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/transaction/transaksiJurnal"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/transaction/transaksiJurnal"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-comments-dollar" />
                    </i>{" "}
                    Transaksi Jurnal
                  </Link>
                </li>
              </ul>

              {/* Divider */}
              <hr className="my-4 md:min-w-full" />
              {/* Heading */}
              <h6
                onClick={() => setReportDropdown(!reportDropdown)}
                className="md:min-w-full text-blueGray-500 text-xs cursor-pointer uppercase font-bold block pt-1 pb-4 no-underline"
              >
                Reports
              </h6>

              {/* Navigation */}
              <ul
                className={
                  reportDropdown === false
                    ? " md:min-w-full list-none md:flex-col flex flex-col"
                    : " md:min-w-full list-none md:flex-col hidden flex-col"
                }
              >
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/report/LaporanJurnal") !==
                      -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/report/LaporanJurnal"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/report/LaporanJurnal"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-brain" />
                    </i>{" "}
                    Jurnal Umum
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/report/BukuBesar") !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/report/BukuBesar"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf("/report/BukuBesar") !==
                        -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-book" />
                    </i>{" "}
                    Buku Besar
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/report/LabaRugi") !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/report/LabaRugi"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf("/report/LabaRugi") !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-chart-bar" />
                    </i>{" "}
                    Laba Rugi
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/report/Neraca") !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/report/Neraca"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf("/report/Neraca") !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-scale-balanced" />
                    </i>{" "}
                    Neraca
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf("/report/ArusKas") !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/report/ArusKas"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf("/report/ArusKas") !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-sailboat" />
                    </i>{" "}
                    Arus Kas
                  </Link>
                </li>
              </ul>

              {/* Divider */}
              {/* <hr className="my-4 md:min-w-full" /> */}
              {/* Heading */}
              {/* <h6 className="md:min-w-full text-blueGray-500 text-xs cursor-pointer uppercase font-bold block pt-1 pb-4 no-underline">
              Admin Layout Pages
            </h6> */}
              {/* Navigation */}

              <ul className="md:flex-col md:min-w-full flex flex-col list-none">
                {/* <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/dashboard") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/dashboard"
                >
                  <i
                    className={
                      "fas fa-tv mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/dashboard") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Dashboard
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/settings") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/settings"
                >
                  <i
                    className={
                      "fas fa-tools mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/settings") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Settings
                </Link>
              </li> */}

                {/* <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/tables") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/tables"
                >
                  <i
                    className={
                      "fas fa-table mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/tables") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Tables
                </Link>
              </li> */}

                {/* <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/maps") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/maps"
                >
                  <i
                    className={
                      "fas fa-map-marked mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/maps") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Maps
                </Link>
              </li> */}
              </ul>

              {/* Divider */}
              {/* <hr className="my-4 md:min-w-full" /> */}
              {/* Heading */}
              {/* <h6 className="md:min-w-full text-blueGray-500 text-xs cursor-pointer uppercase font-bold block pt-1 pb-4 no-underline">
              Auth Layout Pages
            </h6> */}
              {/* Navigation */}

              {/* <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
              <li className="items-center">
                <Link
                  className="text-blueGray-700 hover:text-blueGray-500 text-xs uppercase py-3 font-bold block"
                  to="/auth/login"
                >
                  <i className="fas fa-fingerprint text-blueGray-400 mr-2 text-sm"></i>{" "}
                  Login
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className="text-blueGray-700 hover:text-blueGray-500 text-xs uppercase py-3 font-bold block"
                  to="/auth/register"
                >
                  <i className="fas fa-clipboard-list text-blueGray-300 mr-2 text-sm"></i>{" "}
                  Register
                </Link>
              </li>
            </ul> */}

              {/* Divider */}
              {/* <hr className="my-4 md:min-w-full" /> */}
              {/* Heading */}
              {/* <h6 className="md:min-w-full text-blueGray-500 text-xs cursor-pointer uppercase font-bold block pt-1 pb-4 no-underline">
              No Layout Pages
            </h6> */}
              {/* Navigation */}

              {/* <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
              <li className="items-center">
                <Link
                  className="text-blueGray-700 hover:text-blueGray-500 text-xs uppercase py-3 font-bold block"
                  to="/landing"
                >
                  <i className="fas fa-newspaper text-blueGray-400 mr-2 text-sm"></i>{" "}
                  Landing Page
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className="text-blueGray-700 hover:text-blueGray-500 text-xs uppercase py-3 font-bold block"
                  to="/profile"
                >
                  <i className="fas fa-user-circle text-blueGray-400 mr-2 text-sm"></i>{" "}
                  Profile Page
                </Link>
              </li>
            </ul> */}

              {/* Divider */}
              <hr className="my-4 md:min-w-full" />
            </div>
          </div>
        </nav>
      </>
    );
  } else {
    return (
      <>
        <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-15 py-4 px-6">
          <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
            {/* Toggler */}
            <button
              className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
              type="button"
              onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
            >
              {/* <i className="fas fa-bars"></i> */}
              <i>
                <FontAwesomeIcon icon="fas fa-bars" />
              </i>
            </button>
            {/* Brand */}
            <Link
              className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
              to="/masterData"
            >
              Sistem Keuangan ALC
            </Link>
            {/* User */}
            <ul className="md:hidden items-center flex flex-wrap list-none">
              <li className="inline-block relative">
                {/* <NotificationDropdown /> */}
              </li>
              <li className="inline-block relative">
                <UserDropdown />
              </li>
            </ul>
            {/* Collapse */}
            <div
              className={
                "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
                collapseShow
              }
            >
              {/* Collapse header */}
              <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
                <div className="flex flex-wrap">
                  <div className="w-6/12">
                    <Link
                      className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                      to="/masterData"
                    >
                      Sistem Keuangan ALC
                    </Link>
                  </div>
                  <div className="w-6/12 flex justify-end">
                    <button
                      type="button"
                      className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                      onClick={() => setCollapseShow("hidden")}
                    >
                      {/* <i className="fas fa-times"></i> */}
                      <i>
                        <FontAwesomeIcon icon="fas fa-times" />
                      </i>
                    </button>
                  </div>
                </div>
              </div>
              {/* Form */}
              {/* <form className="mt-6 mb-4 md:hidden">
                  <div className="mb-3 pt-0">
                    <input
                      type="text"
                      placeholder="Search"
                      className="px-3 py-2 h-12 border border-solid  border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
                    />
                  </div>
                </form> */}
              {/* Divider */}
              <hr className="my-4 md:min-w-full" />
              {/* Heading */}
              <h6 className="md:min-w-full text-blueGray-500 text-xs cursor-pointer uppercase font-bold block pt-1 pb-4 no-underline">
                Transaction
              </h6>
              {/* Navigation */}
              <ul className="md:flex-col md:min-w-full flex flex-col list-none">
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/transaction/transaksiMasuk"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/transaction/transaksiMasuk"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/transaction/transaksiMasuk"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-envelope-open-text" />
                    </i>{" "}
                    Transaksi Masuk
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/transaction/transaksiKeluar"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/transaction/transaksiKeluar"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/transaction/transaksiKeluar"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-mail-bulk" />
                    </i>{" "}
                    Transaksi Keluar
                  </Link>
                </li>
                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      (window.location.href.indexOf(
                        "/transaction/transaksiJurnal"
                      ) !== -1
                        ? "text-lightBlue-500 hover:text-lightBlue-600"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/transaction/transaksiJurnal"
                  >
                    <i
                      className={
                        "mr-2 text-sm " +
                        (window.location.href.indexOf(
                          "/transaction/transaksiJurnal"
                        ) !== -1
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    >
                      <FontAwesomeIcon icon="fas fa-comments-dollar" />
                    </i>{" "}
                    Transaksi Jurnal
                  </Link>
                </li>
              </ul>
              {/* Divider */}
              <hr className="my-4 md:min-w-full" />
              {/* Heading */}
            </div>
          </div>
        </nav>
      </>
    );
  }
}
